export default function () {
  const widgetName = 'masonryCards';
  const widgetOpts = masonryCardsOpts;
  const wrapContainerClass = 'masonry-wrap-container';
  const $widget = $(`#${widgetName}`);

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    maxItemsVisible: 6,
    itemsPerPanel: 6,
    showDescription: false,
    moreButton: false,
    buyNowButton: false,
    cardWidgetLoaded: function (data) {
      const widgetItems = data.items;

      if (widgetItems.length == 0) {
        $(`.${wrapContainerClass}`).remove();
      } else {
        $widget.addClass(`grid-${widgetItems.length}`);
        createGallery(widgetItems);
      }
    },
  });

  // ****************************************************************
  // Function Helpers
  function createGallery(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { URL } = widgetData[x];
      const $card = $(this);

      $card.removeAttr('target');
      if (!URL) {
        $card.removeAttr('href');
      }
    });
  }
}
